import { ReactNode } from 'react';

import { ReportsMessage } from '../../../types/SpecificReportMessage';
import { BaseStatisticsMessage } from '../../../types/StatisticsMessage';
import { DynamicFilterContainer, Filter } from '../../cdl/Filter/DynamicFilterContainer/DynamicFilterContainer';
import { FilterMultiSelectFull } from '../../cdl/Filter/FilterMultiSelectFull/FilterMultiSelectFull';
import { translate } from '../../common/helpers/translate.helper';

interface PortsTabFilterProps {
    allEntries: BaseStatisticsMessage['port'];
    children: (filteredEntries: BaseStatisticsMessage['port']) => ReactNode;
}

export const PortsTabFilter = ({ children, allEntries }: PortsTabFilterProps) => {
    const portFilter: Filter<string, ReportsMessage> = {
        filterFn: (values, entry) => {
            return values.includes(entry.context.id);
        },
        component: (values, setValues) => {
            const availableOptions = Array.from(new Set(allEntries.map((entry) => entry.context.id))).map((portId) => ({
                label: allEntries.find((entry) => entry.context.id === portId)?.context.name ?? '',
                value: portId,
            }));

            return (
                <FilterMultiSelectFull
                    options={availableOptions}
                    values={values}
                    onChange={setValues}
                    label={translate('reporting.filter.port.title')}
                    filterByLabel={translate('reporting.filter.port.filterByPort')}
                    filterPlaceholder={translate('reporting.filter.port.searchForPort')}
                />
            );
        },
    };

    return (
        <DynamicFilterContainer allEntries={allEntries} filters={{ port: portFilter }}>
            {children}
        </DynamicFilterContainer>
    );
};
